function changeBasicFields( fieldName, fieldValue ) {
	return {
		type: 'CHANGE_BASIC_FIELDS',
		payLoad: {
			fieldName,
			fieldValue
		}
	}
}

function changeMainField( name, value ) {
	return {
		type: 'CHANGE_MAIN_FIELD',
		payLoad: {
			name,
			value
		}
	}
}

function showCurrentRoute( value ) {
	return {
		type: 'SHOW_CURRENT_ROUTE',
		payLoad: {
			value
		}
	}
}

export { changeBasicFields, changeMainField, showCurrentRoute };